// barbiefy.ts
let styleEl: HTMLStyleElement | null = null
let initialized = false
let locked = false

function injectStyle() {
	if (styleEl) styleEl.remove()
	styleEl = document.createElement('style')
	styleEl.textContent = `
    html.barbiefy {
      filter: invert(1) hue-rotate(30deg) saturate(1.5) brightness(1.1);
      transition: filter .25s ease;
    }

	html.barbiefy .clb-row{
      filter: invert(1) hue-rotate(30deg) saturate(1.5) brightness(1.1);
		}

    html.barbiefy #panel-camera img,
	html.barbiefy .lgd-ico{
      filter: invert(1) hue-rotate(-30deg) saturate(0.67) brightness(0.91);
    }
	 html.barbiefy #sidebar,
	html.barbiefy .leaflet-searchbox,
	html.barbiefy .leaflet-control-zoom-in,
	html.barbiefy .leaflet-control-zoom-out,
	html.barbiefy .status-legend{
      filter: invert(1) hue-rotate(-30deg) saturate(0.67) brightness(0.91);
	--tw-bg-opacity: 1;
    background-color: #fbcfe8!important;
    }

	 html.barbiefy #sidebar .bp-header,
	 html.barbiefy .highcharts-plot-background{
	--tw-bg-opacity: 1;
    background-color: rgb(251 207 232 / var(--tw-bg-opacity, 1));
    }

	html.barbiefy #legend-body .chip,
	html.barbiefy .leaflet-searchbox-input,
	html.barbiefy .leaflet-searchbox-item li {
		background-color: rgb(251 207 232);
		border-color: white;
		border-width: 2px;
	}

	 html.barbiefy #sidebar h2,
  html.barbiefy #sidebar label,
  html.barbiefy #sidebar span,
  html.barbiefy #sidebar i,
  html.barbiefy .leaflet-control-zoom span,
	html.barbiefy .leaflet-searchbox-input,
	html.barbiefy .leaflet-searchbox-input::placeholder,
	html.barbiefy .leaflet-searchbox-list,
	html.barbiefy .leaflet-searchbox-item,
	html.barbiefy .status-legend span,
	html.barbiefy .status-legend em,
	html.barbiefy .status-legend .clb-title,
	html.barbiefy .bp-block,
	html.barbiefy .bp-block h3,
	html.barbiefy .bp-block p{
	  font-size: 120%;
	  text-shadow: rgb(255, 255, 255) -2px -2px 0px, rgb(255, 255, 255) 2px -2px 0px, rgb(255, 255, 255) -2px 2px 0px, rgb(255, 255, 255) 2px 2px 0px;
		--tw-text-opacity: 1;
		color: rgb(236 72 153);
	font-family: 'Pacifico', cursive;
    background-color: rgb(251 207 232);
    }
  `;
	document.head.appendChild(styleEl)
}

function shouldIgnore(t: EventTarget | null) {
	if (!(t instanceof HTMLElement)) return false
	const tag = t.tagName.toLowerCase()
	return tag === 'input' || tag === 'textarea' || t.isContentEditable
}

export function barbiefyOn() {
	document.documentElement.classList.add('barbiefy')
}

export function barbiefyOff() {
	document.documentElement.classList.remove('barbiefy')
}

export function barbiefyToggle() {
	document.documentElement.classList.toggle('barbiefy')
}

export function setupBarbiefyHotkey() {
	if (initialized) return
	initialized = true
	injectStyle()

	window.addEventListener('keydown', e => {
		if (locked) return
		if (e.repeat) return
		if (shouldIgnore(e.target)) return
		const isB = e.code === 'KeyB' || e.key.toLowerCase() === 'b'
		if (e.altKey && isB) {
			e.preventDefault()
			e.stopPropagation()
			barbiefyToggle()
			locked = true
		}
	}, { capture: true })

	const unlock = (e: KeyboardEvent) => {
		if (e.key === 'Alt' || e.code === 'KeyB' || e.key.toLowerCase() === 'b') locked = false
	}
	window.addEventListener('keyup', unlock, { capture: true })
	window.addEventListener('blur', () => { locked = false }, { capture: true })
}
